import { useState, useEffect, Fragment } from "react";
import { Form, Input, Select, Button, message } from "antd";
import { ExamLabel } from "../../components/commons";
import { storeParticipanteAcount } from "../../api/participante";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getConfig } from "../../api/sistema";
import * as SHARED from "../../utils/shared";

const { Option } = Select;

const ParticipanteInscribirse = () => {
  const history = useHistory();
  const [isSending, setIsSending] = useState(false);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const participante = query.get("participante");
  const participacion = query.get("participacion");
  const personalmedico = query.get("personalmedico");
  const [tipoParticipante, setTipoParticipante] = useState([
    {
      name: SHARED.DOCENTE_NAME_CAPITALIZED,
      value: SHARED.ID_TIPO_PARTICIPANTE_DOCENTE
    },
    {
      name: SHARED.ADMINISTRATIVO_NAME_CAPITALIZED,
      value: SHARED.ID_TIPO_PARTICIPANTE_ADMINISTRATIVO
    },
    {
      name: SHARED.ESTUDIANTE_NAME_CAPITALIZED,
      value: SHARED.ID_TIPO_PARTICIPANTE_ESTUDIANTE
    }
  ]);
  const [config, setConfig] = useState({
    activoSolicitaContrasenia: false
  });

  const [isLoading, setIsLoading] = useState(false);

  const fetchConfig = async () => {
    try {
      setIsLoading(true);
      const res = await getConfig();
      setConfig(res.payload);
    } catch (err) {
      setConfig({
        activoSolicitaContrasenia: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
    if (Boolean(personalmedico)) {
      setTipoParticipante([
        {
          name: SHARED.DOCENTE_NAME_CAPITALIZED + " (personal médico)",
          value: SHARED.ID_TIPO_PARTICIPANTE_DOCENTE
        },
        {
          name: SHARED.ADMINISTRATIVO_NAME_CAPITALIZED + " (personal médico)",
          value: SHARED.ID_TIPO_PARTICIPANTE_ADMINISTRATIVO
        }
      ]);
    }
  }, [personalmedico]);

  const onFinish = (values) => {
    const { email, idtipoparticipante, idtipoparticipacion } = values;

    sendPassword({
      email,
      idtipoparticipante,
      idtipoparticipacion,
      personalmedico: Boolean(personalmedico)
    });
  };

  const sendPassword = async (data) => {
    try {
      setIsSending(true);
      const response = await storeParticipanteAcount(data);
      if (response) {
        message.success(response.message);
        history.push("/");
      }
    } catch (err) {
      message.error(err.message);
    } finally {
      setIsSending(false);
    }
  };

  const tiposDeParticipacion = [
    {
      name: SHARED.TIPO_DE_PARTICIPACION_INTERNAMIENTO_NOMBRE_COMPLETO_CAPITALIZED,
      value: SHARED.ID_INTERNAMIENTO
    },
    {
      name: SHARED.TIPO_DE_PARTICIPACION_SUPERVISION_NOMBRE_COMPLETO_CAPITALIZED,
      value: SHARED.ID_SUPERVISION
    }
  ];

  return (
    <Fragment>
      <div className="max-w-xs mx-auto">
        <ExamLabel
          firstTitle={`Enviar contraseña para ingresar al ${SHARED.NOMBRE_SISTEMA}`}
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />
      </div>

      <Form onFinish={onFinish} className="max-w-xs mx-auto text-center" layout="vertical">
        <Form.Item
          name="idtipoparticipante"
          label="En la universidad usted es"
          initialValue={participante ? Number(participante) : null}
          rules={[{ required: true, message: "Este campo es requerido" }]}
        >
          <Select placeholder="Seleccione una opción" className="text-base">
            {tipoParticipante.map((item) => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="idtipoparticipacion"
          label="Elija una modalidad de participación"
          initialValue={Number(participacion)}
          rules={[{ required: true, message: "Este campo es requerido" }]}
        >
          <Select className="text-base" placeholder="Seleccione una opción">
            {tiposDeParticipacion.map((item) => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="email"
          label="Correo electrónico institucional"
          rules={[{ required: true, message: "El correo electrónico es necesario" }]}
        >
          <Input type="email" />
        </Form.Item>

        <div
          className={`bg-gray-100 border-t-4 mb-8 rounded-b text-teal-900 px-4 py-3 shadow-md`}
          role="alert"
        >
          <div className="text-center">
            <p className="text-sm">
              RECUERDE QUE DEBE UTILIZAR SU CORREO INSTITUCIONAL PARA SOLICITAR LA CONTRASEÑA
            </p>
            <p>
              <b>Ejemplo: jperezh@unjbg.edu.pe</b>
            </p>
          </div>
        </div>

        <Form.Item>
          <Button
            type="primary"
            block
            loading={isLoading || isSending}
            disabled={!config.activoSolicitaContrasenia}
            htmlType="submit"
          >
            Enviar contraseña
          </Button>
        </Form.Item>

        <Link to="/reenviar-contrasenia">
          <Button className="mb-2" type="link" block>
            Olvidé mi contraseña
          </Button>
        </Link>
        <Link to="/">
          <Button className="mb-6" type="link" block>
            Regresar a Iniciar sesión
          </Button>
        </Link>
      </Form>
    </Fragment>
  );
};

export default ParticipanteInscribirse;
